<template>
  <div class="wrapper-create-nav height-all">
    <div
      class="wrapper-create-nav-btn pointer"
      :class="{ active: route.name === 'create'|| route.name === 'createIndex'}"
      @click="() => goCreateDetailPage()"
    >
      <span class="fn-inline"> {{ $$t("tts.create_song") }}</span>
    </div>
    <div
      class="wrapper-create-nav-btn pointer"
      :class="{ active: route.name === 'instrumental' }"
      @click="() => goInstrumentalPage()"
    >
      <span class="fn-inline"> {{ $$t("common.bgm") }}</span>
    </div>
    <div
      v-if="ModuleOpenStateControl.editor.opened"
      class="wrapper-create-nav-btn pointer"
      :class="{ active: route.name === 'editor' }"
      @click="() => goEditorPage()"
    >
      <span class="fn-inline"> {{ $$t("common.audio_edit") }}</span>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { useRoute, useRouter } from "vue-router";
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};
import useCreateRenderType from "@/store/create/createLayoutStore.js"

const router = useRouter();

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

const createRenderType = useCreateRenderType()

const {
  toggleCreateEditOpenState,
  toggleEditorOpenState,
  toggleBgmCreateEditOpenState,
} = createRenderType
const Router = useRouter();
const route = useRoute();

const props = defineProps({});
const emits = defineEmits([]);
const renderData = reactive({});
const goCreateDetailPage = async () => {
  await router.push({
    name: "create",
  });
  toggleCreateEditOpenState(true);
};

const goEditorPage = async () => {
  await router.push({
    name: "editor",
  });
  toggleEditorOpenState(true);
};

const goInstrumentalPage = async () => {
  await router.push({
    name: "instrumental",
  });
  toggleBgmCreateEditOpenState(true);
};
onMounted(() => {});
</script>
<style lang="scss">
.wrapper-create-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: unset;
  overflow-x: auto;
  .wrapper-create-nav-btn {
    font-weight: 400;
    font-size: 16px;
    line-height: 40px;
    margin: 0 20px 0 0;
    color: rgba(255, 255, 255, 0.8);
    transition: unset;
    min-width: max-content;
    &:last-child {
      margin: 0;
    }
  }
  .wrapper-create-nav-btn.active {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
